import React from 'react'

const CloseIcon = props => (
  <svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M11.8479 10.4379a.4999.4999 0 010 .71l-.7.7a.4999.4999 0 01-.71 0l-4.44-4.44-4.44 4.44a.4998.4998 0 01-.71 0l-.7-.7a.5.5 0 010-.71l4.44-4.44-4.44-4.44a.5.5 0 010-.71l.7-.7a.5.5 0 01.71 0l4.44 4.44 4.44-4.44a.5.5 0 01.71 0l.7.7a.4998.4998 0 010 .71l-4.44 4.44 4.44 4.44z"
      fill="currentColor"
    />
  </svg>
)

export default CloseIcon
